<template>
  <div
    :class="[wrapperClass, { 'has-error has-danger': validator && validator.$error && !wrapped }]">

    <div
      v-if="wrapped"
      :id="'radio-button-wrapper-' + id"
      :class="[{ 'has-error has-danger': validator && validator.$error || errors }, radioWrapperClass]"
    />
    <slot name="icon"/>

    <div v-for="(option, i) in options"
         :key="option[optionLabel] + i"
         class="form-check">
      <label class="form-check-label radio">
        <input
          :id="optionValue ? option[optionValue] : ''"
          :value="optionValue ? option[optionValue] : option"
          :checked="option.default"
          :name="radiosName"
          :class="[radioClass]"
          v-model="field"
          type="radio"
          @change="!validator || validator.$touch()">
        {{ option[optionLabel] }}
        <span class="checkmark"/>
      </label>
    </div>
    <div
      :id="'textarea-help-block-' + id"
      class="help-block form-text form-control-feedback">
      <template v-for="(error, index) in errors">
        <strong :key="index"> {{ error }} </strong>
      </template>
      <strong v-if="validator && validator.$params.required && validator.$error && !validator.required">*</strong>
    </div>
  </div>
</template>

<script>
export default {
	name: 't-radio',
	props: {
		label: {
			type: String,
			default: 'Radio'
		},
		labelClass: {
			type: String,
			default: 'col-form-label col-sm-4'
		},
		radioClass: {
			type: String,
			default: 'form-check-input'
		},
		wrapperClass: {
			type: String,
			default: 'form-row'
		},
		radioWrapperClass: {
			type: String,
			default: 'col-sm-8'
		},
		options: {
			type: Array,
			default: () => []
		},
		optionLabel: {
			type: String,
			default: ''
		},
		optionValue: {
			type: String,
			default: ''
		},
		value: {
			type: [Number, String, Object, Array, Boolean],
			default: null
		},
		validator: {
			type: Object,
			default: null
		},
		errors: {
			type: Array,
			default: () => null
		},
		wrapped: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		radiosName () {
			return Math.random().toString().replace('0.', '')
		},
		field: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
		id () {
			return (
				't-radio-' +
        Math.random()
        	.toString()
        	.replace('0.', '')
			)
		}
	},
	mounted () {
		if (this.wrapped) {
			let wrapper = document.getElementById(`radio-wrapper-${this.id}`)
			let radio = document.getElementById(this.id)
			let helpBlock = document.getElementById(`radio-help-block-${this.id}`)
			wrapper.appendChild(radio)
			wrapper.appendChild(helpBlock)
		}

		this.$emit('input', this.field)
	}
}
</script>
<style>
label.form-check-label.radio .checkmark {
    border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/radio/index.vue